import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setScreenHeight, setScreenWidth } from '@/redux/app/appSlice';

// Сохранение размеров вьюпорта
const useWindowSize = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleResize = () => {
      const html = document.documentElement;

      html.style.setProperty('--window-height', `${window.innerHeight}px`);
      dispatch(setScreenHeight(window.innerHeight));

      html.style.setProperty('--window-width', `${window.innerWidth}px`);
      dispatch(setScreenWidth(window.innerWidth));
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [dispatch]);
};

export default useWindowSize;
